// extracted by mini-css-extract-plugin
export default {"markdownContent":"BundleSignUpLandingPage_markdownContent__bZ-Wy"};